import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment'
import BColor from '../BColor'

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        // '&:nth-of-type(odd)': {
        //     backgroundColor: theme.palette.background.default,
        // },
    },
}))(TableRow);

function createData(ymd, concent, concentd5, concentd20) {
    return { ymd, concent, concentd5, concentd20 };
}


const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 250,
    backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000"
  },
}));

export default function ConcentrationDetail(props) {
    const classes = useStyles();
    const [buyselldata, setBuyselldata] = React.useState([]);

    useEffect(() => {
        if (props.open) fectchStockData(props.stockId)
    }, [props.stockId]);


    function fectchStockData(stockId) {
        if (stockId != null) {
            let a = {
                sid: stockId
            };

            fetch("/jstock/v1/stock/concentration", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(a)
            })
                .then(res => res.json())
                .then(
                    result => {
                        let dd = result.bs.map(row =>
                            createData(moment(row.ymd, "YYYYMMDD").format('YYYY/MM/DD'), row.concent, row.concentd5, row.concentd20)
                        )
                        setBuyselldata(dd)
                    },
                    error => {
                    }
                );
        }
    }


    const renderSellerV1 = (value, baseValue) => {
        if (value === -99999) {
            return <Button size= "small" variant="outlined" style={{ whiteSpace: "nowrap", minWidth: 90, color: BColor.nodatacolor }} className={classes.button1} >
                -
          </Button>
        } else if (value <= -baseValue) {
            return <Button  size= "small" style={{whiteSpace: "nowrap",  minWidth: 90, background: BColor.downcolorbox, color: '#FFFFFF' }} className={classes.button1}>
                高度{value}%
          </Button>
        } else if (value < 0 && value > -baseValue) {
            return <Button  size= "small" variant="outlined" style={{ whiteSpace: "nowrap", minWidth: 90, color: BColor.downcolorbox }} className={classes.button1}>
                中度{value}%
        </Button>
        } else if (value === 0) {
            return <Button size= "small" variant="outlined" style={{ whiteSpace: "nowrap", minWidth: 90, color: BColor.faircolor }} className={classes.button1} >
                持平{value}%
          </Button>
        } else if (value > 0 && value < baseValue) {
            return <Button  size= "small" variant="outlined" style={{ whiteSpace: "nowrap", minWidth: 90, color: BColor.upcolorbox }} className={classes.button1} >
                中度{value}%
        </Button>
        } else if (value >= baseValue) {
            return <Button  size= "small" style={{ whiteSpace: "nowrap", minWidth: 90, background: BColor.upcolorbox, color: '#FFFFFF' }} className={classes.button1} >
                高度{value}%
        </Button>
        } else {
            return <Button  size= "small" variant="outlined" style={{whiteSpace: "nowrap",  minWidth: 90, color: BColor.nodatacolor }} className={classes.button1} >
                -
          </Button>
        }
    }

    return (
        <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">集中度表</DialogTitle>

            <DialogContent>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table" size="small">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>日期</StyledTableCell>
                                <StyledTableCell align="right" style={{whiteSpace: "nowrap", }}>1日集中度(％)</StyledTableCell>
                                <StyledTableCell align="right"  style={{whiteSpace: "nowrap", }}>5日集中度(％)</StyledTableCell>
                                <StyledTableCell align="right"  style={{whiteSpace: "nowrap", }}>20日集中度(％)</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {buyselldata.map(row => (
                                <StyledTableRow key={row.ymd}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.ymd}
                                    </StyledTableCell>
                                    <StyledTableCell align="right" style={{}}>{renderSellerV1(row.concent, 25)}</StyledTableCell>
                                    <StyledTableCell align="right" style={{}}>{renderSellerV1(row.concentd5, 20)}</StyledTableCell>
                                    <StyledTableCell align="right" style={{}}>{renderSellerV1(row.concentd20, 20)}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                {/* <Button onClick={props.handleClose} color="primary">
                    取消
          </Button> */}
                <Button onClick={props.handleClose} color="primary">
                    關閉
          </Button>
            </DialogActions>
        </Dialog>
    );
}
